import { useState, useRef } from "react";
import { Link } from "react-router-dom"; 

const DropdownMenu = ({ items, isOpen, onClose }) => {
  return (
    isOpen && (
      <ul
        className="absolute bg-white shadow-md rounded-lg mt-2 dropdown"
        onMouseLeave={onClose}
      >
        <Dropdown items={items} />
      </ul>
    )
  );
};

const Dropdown = ({ items }) => {
  return (
    <ul>
      {items.map((item, index) => (
        <li key={index}>
          <Link
            to={`/${item.toLowerCase().replace(/\s+/g, '-')}`}
            className="block px-7 py-2 text-sky-950 hover:bg-gray-100"
          >
            {item}
          </Link>
        </li>
      ))}
    </ul>
  );
};

const HeaderNavigationBar = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const timeoutRef = useRef(null);

  const handleMouseEnter = (dropdown) => {
    clearTimeout(timeoutRef.current);
    setActiveDropdown(dropdown);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setActiveDropdown(null);
    }, 100);
  };

  const getInvolvedPages = ["Donate"];
  const aboutUsPages = ["Our Projects"];

  return (
    <header className="text-white font-nunito fixed top-0 left-0 w-full blue-bg p-4 shadow-md z-10">
      <nav className="flex justify-between items-center mx-4 md:mx-20">
        <Link to="/"><h1 className="text-xl md:text-2xl">Nisa & Sabir Foundation</h1></Link>

        <button
          className="md:hidden text-2xl text-white focus:outline-none"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          ☰
        </button>

        <ul className="hidden md:flex space-x-4 relative">
          <li
            className="group relative"
            onMouseEnter={() => handleMouseEnter('aboutUs')}
            onMouseLeave={handleMouseLeave}
          >
            <Link to="/" className="cursor-pointer hover:underline">About Us</Link>
            <DropdownMenu
              items={aboutUsPages}
              isOpen={activeDropdown === 'aboutUs'}
              onClose={() => setActiveDropdown(null)}
            />
          </li>

          <li
            className="group relative"
            onMouseEnter={() => handleMouseEnter('getInvolved')}
            onMouseLeave={handleMouseLeave}
          >
            <Link to="/get-involved" className="cursor-pointer hover:underline">Get Involved</Link>
            <DropdownMenu
              items={getInvolvedPages}
              isOpen={activeDropdown === 'getInvolved'}
              onClose={() => setActiveDropdown(null)}
            />
          </li>

          <li>
            <Link to="/contact" className="hover:underline">Contact Us</Link>
          </li>
        </ul>

        {mobileMenuOpen && (
          <ul className="md:hidden absolute top-full left-0 w-full bg-white text-sky-950 shadow-md rounded-b-lg p-4 space-y-2 z-20">
            <li>
              <Link to="/" className="block hover:underline" onClick={() => setMobileMenuOpen(false)}>About Us</Link>
            </li>
            {aboutUsPages.map((page, idx) => (
              <li key={idx}>
                <Link
                  to={`/${page.toLowerCase().replace(/\s+/g, '-')}`}
                  className="block px-4 hover:bg-gray-100"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {page}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/get-involved" className="block hover:underline" onClick={() => setMobileMenuOpen(false)}>Get Involved</Link>
            </li>
            {getInvolvedPages.map((page, idx) => (
              <li key={idx}>
                <Link
                  to={`/${page.toLowerCase().replace(/\s+/g, '-')}`}
                  className="block px-4 hover:bg-gray-100"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {page}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/contact" className="block hover:underline" onClick={() => setMobileMenuOpen(false)}>Contact Us</Link>
            </li>
          </ul>
        )}
        
      </nav>
    </header>
  );
};

export default HeaderNavigationBar;
